/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  SettingsService,
  ISettingsMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  IUpdateAllInventoryMethods,
  UpdateAllInventoryService,
  IInventoryMethods,
  UpdateInventoryService,
  IUpdateInventoryMethods,
  InventoryService,
  FeaturesService,
  IFeaturesMethods,
  IAttributesMethods,
  AttributesService,
  IValuesMethods,
  ValuesService,
  FilterOptionsService,
  IFilterOptionsMethods,
  IPresentationsMethods,
  PresentationsService,
  IPresentationsModalMethods,
  PresentationsModalService,
} from "./components";

export type SectionOptionInventoryReportPageAgent = IHeaderMethods &
  ISettingsMethods &
  IStaticPageContentMethods &
  IUpdateAllInventoryMethods &
  IUpdateInventoryMethods &
  IFeaturesMethods &
  IPresentationsModalMethods &
  IInventoryMethods &
  IPresentationsMethods &
  IValuesMethods &
  IAttributesMethods &
  IFilterOptionsMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new HeaderService(),
    new SettingsService(),
    new InventoryService(),
    new PresentationsService(),
    new PresentationsModalService(),
    new UpdateAllInventoryService(),
    new UpdateInventoryService(),
    new FeaturesService(),
    new AttributesService(),
    new ValuesService(),
    new FilterOptionsService(),
  ];
};

export const getAgent = () => {
  return createAgent<SectionOptionInventoryReportPageAgent>({
    plugins: getPlugins(),
  });
};
